import * as React from "react";
const SvgIconLine = props => <svg width={1} height={50} viewBox="0 0 1 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><line x1={0.5} y1={2.18557e-8} x2={0.499998} y2={50} stroke="#001246" /></svg>;
export default SvgIconLine;